// @flow

// Libs
import React, { PureComponent } from 'react'

// Components
import { ImageOverlay } from 'react-leaflet'

// Utils
import getUrl from 'hfty-utils/url'

type Props = {
  layer: ?Object,
  toggled: boolean,
  token: string,
}

class SoilTestLayers extends PureComponent {
  props: Props

  render (): React.Element<any> {
    const {
      layer,
      toggled,
      token,
    } = this.props
    return (
      toggled && layer
        ? <ImageOverlay
          url={getUrl({
            token: token,
            path: layer.url,
            excludeTrailingSlash: true,
          })}
          bounds={layer.bounds}
          zIndex={401}
        />
        : null
    )
  }
}

export default SoilTestLayers
